import React, { useContext, useState } from "react";
import Sidebar from "../Sidebar";
import { LoginContext } from "../../context/loginContext";
import { Redirect } from "react-router-dom";
import ScreenLoader from "./ScreenLoader";
import Navbar from "../Navbar/Navbar";

function AfterLogin(props) {
  const [showSide, setshowSide] = useState(false);
  const [state] = useContext(LoginContext);
  return (
    <>
      {state.loading ? (
        <ScreenLoader />
      ) : state.isLogin ? (
        <>
          <div
            onClick={() => setshowSide(false)}
            className={`bg-gray-700 z-30 flex min-h-screen w-full fixed opacity-75 ${
              showSide ? "lg:hidden sm:flex" : "lg:hidden md:hidden hidden"
            } `}
          ></div>
          {/* <div className="lg:hidden bg-white fixed w-full"> */}
          {/* </div> */}
          <Navbar handleShowSide={() => setshowSide(!showSide)} />
          <div className="grid grid-cols-12 content-center w-full pr-0 lg:pr-16">
            <div className="col-span-3">
              <Sidebar handleShowSide={(e) => setshowSide(e)} show={showSide} />
            </div>
            <div className="lg:col-span-9 mb-8 col-span-12 sm:px-4 lg:mt-16 mt-32">
              {props.children}
            </div>
          </div>
        </>
      ) : (
        <Redirect path="/" />
      )}
    </>
  );
}

export default AfterLogin;
